<template>
  <div class="m-side-menu">
    <n-scrollbar style="max-height: calc(100vh - 112px)">
      <slot />
    </n-scrollbar>
  </div>
</template>

<style lang="scss" scoped>
.m-side-menu {
  height: fit-content;
  position: sticky;
  top: 85px;
  margin-bottom: 20px;
}
</style>
